<ng-container *ngIf="(accessToken$ | async) as accessToken">
  <awair-organization-list [activatedOrganizations]="activatedOrganizations$ | async"
                           [deactivatedOrganizations]="deactivatedOrganizations$ | async"
                           [pendingOrganizations]="pendingOrganizations$ | async"
                           [isLoading]="isEnteringOrganization"
                           [isDialog]="false"
                           (createOrganization)="onCreateOrganization()"
                           (enterOrganization)="onEnterOrganization($event, accessToken)">
  </awair-organization-list>
</ng-container>
